import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the UreticiBilgisiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-uretici-bilgisi',
  templateUrl: 'uretici-bilgisi.html',
})
export class UreticiBilgisiPage {
  cari:any={};
  cariid:any;

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
     public navParams: NavParams) {
       this.cariid=this.ortak.storagePersonelGetir.TCK;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UreticiBilgisiPage');
    this.BilgilerimiGetir();
  }
  BilgilerimiGetir()
  {
    var formData = new FormData();
    formData.append("aranan", this.cariid);
  
    this.bllOrtak.islem(formData, "CariBilgiGetir","", false).then(a => {
     
      var sonuc = <any>a;
      this.cari = sonuc.SonucObject;
      console.log("cari",this.cari)

  })
}
}





// WEBPACK FOOTER //
// ./src/pages/UreticiIslemleri/uretici-bilgisi/uretici-bilgisi.ts